module.exports = __webpack_public_path__ + "static/img/company_news07.336bf4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutMe/company_news07.jpg
// module id = TcfI
// module chunks = 2